import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";

import { LektoAuthService, ProfileConstants } from "@frontends-v3/shared-core";

/** Telas da Plataforma que existem para o leitor (DEV-1104, R1). */
const READER_SECTIONS = ["/action", "/library", "/my-account"];

const isReaderSection = (url: string): boolean =>
  READER_SECTIONS.some(
    (section) =>
      url === section ||
      url.startsWith(`${section}/`) ||
      url.startsWith(`${section}?`) ||
      url.startsWith(`${section}#`)
  );

/**
 * Aluno e Família (leitores) não têm Início, Turmas, Gerenciar atribuição nem Enriquecimento: qualquer
 * rota fora de Atribuições, Biblioteca e Minha conta — inclusive a raiz — leva a `/action` (DEV-1104,
 * R1). Para os demais perfis o guard não faz nada. Orienta a navegação; quem autoriza é o servidor.
 */
export const readerLandingGuard: CanActivateFn & CanActivateChildFn = (_route, state) => {
  if (!ProfileConstants.isReaderProfile(inject(LektoAuthService).authProfile())) return true;
  return isReaderSection(state.url) ? true : inject(Router).createUrlTree(["/action"]);
};
